import Marquee from "react-fast-marquee";

const ITEMS = [
  "$340M+ syndicated",
  "30+ institutional lenders",
  "4.2h average wire time",
  "Zero asset-backed covenants",
  "Revenue-based underwriting",
  "Same-day term sheets",
  "No personal real estate pledge",
];

export default function EditorialMarquee() {
  return (
    <section className="border-y border-white/10 bg-[#0A0D12] py-6 overflow-hidden" data-testid="editorial-marquee">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center">
            <span className="font-editorial italic text-lg sm:text-xl text-zinc-500 px-8 whitespace-nowrap">
              {item}
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-amber-500/60" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
